import React from "react";

import { Button, WarningAlert } from "@/components/ui";

/** Inline and persistent: the rows beneath it read as ids until the names load. */
export function NamesUnavailableAlert({
  onRetry,
  "data-testid": testId,
}: {
  onRetry: () => Promise<void>;
  "data-testid": string;
}): React.ReactElement {
  return (
    <WarningAlert data-testid={testId}>
      <span className="flex flex-wrap items-center gap-3">
        People are shown by id because the workspace could not be loaded.
        <Button
          size="sm"
          variant="outline"
          onClick={() => {
            onRetry().catch(() => undefined);
          }}
        >
          Try again
        </Button>
      </span>
    </WarningAlert>
  );
}
